import { Col, Row, Spin, DatePicker, Button, Input } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import AppTable from "../../components/AppTable/AppTable";
import axiosGet from "../../helpers/AxiosRequest";
import { UrlConstants } from "../../helpers/UrlConstantsHelper";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { DownloadOutlined } from '@ant-design/icons';
import AddDriverCall from "../../components/AppModal/AddDriverCall";

const DriverCallsReports = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [drivercallsList, setdrivercallsList] = useState([]);
  const [copydrivercallsList, setcopydrivercallsList] = useState([]);
  const [fromdate, setfromdate]: any = useState(moment());
  const [ButtonClicked, setIsButtonClicked] = useState("Today");
  const [todayFlag, setTodayFlag] = useState(false);
  const [prevFlag, setPrevFlag] = useState(false);
  const [adddrivercallmodal, setadddrivercallmodal] = useState(false);
  const [todate, settodate]: any = useState(moment());
  const dateFormat = "DD/MM/YYYY";
  const [totalCount, setTotalCount] = useState(0);
  const [SearchText, setsearchText]: any = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [Role, setRole]: any = useState(localStorage.getItem("roleid"));
  const disabledDate = (current: any) => {
    return current && current > moment().endOf("day");
  };
  const disabledFromDate = (current: any) => {
    return current && current > moment(todate).endOf("day");
  };
  const onDateSearch = (
    fromdate: any,
    todate: any,
  ) => {
    DateSearch(
      moment(fromdate).format("YYYY/MM/DD"),
      moment(todate).add("days", 1).format("YYYY/MM/DD"),
    );
  };
  const DateSearch = (
    fromdate: any,
    todate: any,
  ) => {
    setIsLoading(true);
    const options: any = {
      params: {
        fromdate: fromdate,
        todate: todate,
      },
    };
    axiosGet(UrlConstants.getdrivercallsreport, options)
      .then((resp: any) => {
        resp.data.forEach((e: any) => {
          e.key = e.drcallid.toString();
        });
        setIsLoading(false);
        setdrivercallsList(resp.data);
        setcopydrivercallsList(resp.data);
        setTotalCount(resp.tablelength);
      })
      .catch(function (error: any) {
        setIsLoading(false);
        if (error.response) {
          console.log(error.response.data, error.response.status);
          setdrivercallsList([]);
          setcopydrivercallsList([]);
        }
      });
  };
  const onSearchchange = (e: any) => {
    setsearchText(e.target.value);
    globalSearch(e.target.value);
  };

  const globalSearch = (searchText: string) => {
    const lowerSearchText = searchText.toLowerCase();
    const filteredData = drivercallsList.filter((value: any) => {
      const properties = [
        value.cabId?.toString() || "",
      ].map((prop) => prop.toLowerCase());

      return properties.some((prop) => prop.includes(lowerSearchText));
    });

    setcopydrivercallsList(filteredData);
    setFilteredData(filteredData);
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "drcallid",
      key: "Id",
    },
    {
      title: "Cab Id",
      dataIndex: "cabId",
      key: "CabId",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "reatime",
      ellipsis: true,
      render: (text: any, record: any) => {
        return {
          children: <div>{moment(text).format("DD/MM/YYYY")}</div>,
        };
      },
    },
    {
      title: "Time",
      dataIndex: "date",
      key: "reatime",
      ellipsis: true,
      render: (text: any, record: any) => {
        return {
          children: (
            <div>
              {text ? moment(text).format("hh:mm A") : ""}
            </div>
          ),
        };
      },
    },

    {
      title: "Reason",
      dataIndex: "reason",
      key: "Reason",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "Reamraks",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "User",
      dataIndex: "updateBy",
      key: "user",
    }

  ];

  const headersToExport = columns.map((column: any) => ({
    label: column.title,
    key: column.dataIndex || column.title, // Make sure there's a fallback for undefined keys
  }));

  const csvData = drivercallsList.map((value: any) => ({
    ...value,
    permTime: value.permTime ? moment(value.permTime).format("hh:mm A") : "",
    resumeTime: value.resumeTime ? moment(value.resumeTime).format("hh:mm A") : "",
    pStartTime: value.pStartTime ? moment(value.pStartTime).format("hh:mm A") : "",
  }));

  const adayclick = (event: any = null) => {

    var first = moment();
    var firstday = first.format("DD");
    var firstmonth = first.format("MM");
    var firstyear = first.format("YYYY");
    let fromdate = firstyear + "-" + firstmonth + "-" + firstday;
    setfromdate(moment(fromdate));
    //var new_date = moment().add('days', 1);
    var new_date = moment();
    var day = new_date.format("DD");
    var month = new_date.format("MM");
    var year = new_date.format("YYYY");
    let todate = year + "-" + month + "-" + day;
    settodate(moment(todate));
    setTodayFlag(true);
    setPrevFlag(false);
    onDateSearch(fromdate, todate);
  };
  const twodayclick = () => {
    setIsButtonClicked("Yesday");
    var first = moment().add("days", -1);
    var firstday = first.format("DD");
    var firstmonth = first.format("MM");
    var firstyear = first.format("YYYY");
    let fromdate = firstyear + "-" + firstmonth + "-" + firstday;
    setfromdate(moment(fromdate));
    var new_date = moment().add("days", -1);
    //var new_date = moment();
    var day = new_date.format("DD");
    var month = new_date.format("MM");
    var year = new_date.format("YYYY");
    let todate = year + "-" + month + "-" + day;
    settodate(moment(todate));
    setTodayFlag(false);
    setPrevFlag(true);
    onDateSearch(fromdate, todate);
  };
  const monthclick = () => {
    setIsButtonClicked("Month");
    var first = moment();
    var firstmonth = first.format("MM");
    var firstyear = first.format("YYYY");
    let fromdate = firstyear + "-" + firstmonth + "-" + "01";
    setfromdate(moment(fromdate));
    //var new_date = moment().add('days', 1);
    var new_date = moment();
    var day = new_date.format("DD");
    var month = new_date.format("MM");
    var year = new_date.format("YYYY");
    let todate = year + "-" + month + "-" + day;
    settodate(moment(todate));
    setTodayFlag(true);
    setPrevFlag(false);
    onDateSearch(fromdate, todate);
  };

  useEffect(() => {
    // getCustomerList();
    adayclick();
  }, []);
  const onfromdatechange = (value: any) => {
    setfromdate(value);
    try {
      var fromdate = moment(value).format("YYYY/MM/DD");
      let todate = moment().format("YYYY/MM/DD");
      //DateSearch(fromdate, todate);
      setTodayFlag(false);
      setPrevFlag(false);
      //setfromdate(value);
    } catch (ex) {
      console.log(ex);
    }
  };
  const ontodatechange = (value: any) => {
    settodate(value);
    try {
      let startdate = moment(fromdate).format("YYYY/MM/DD");
      setTodayFlag(false);
      setPrevFlag(false);

    } catch (ex) {
      console.log(ex);
    }
  };
  const exportToCSV = (data: any[], columns: any[], fileName = `Driver Calls Report`) => {
    const exportData = data.map((row) => {
      const formattedRow: any = {};

      columns.forEach((col: any) => {
        const key = col.dataIndex;

        let columnTitle = '';
        if (typeof col.title === 'string') {
          columnTitle = col.title;
        } else if (typeof col.title === 'object' && col.title?.props?.children) {
          const children = col.title.props.children;
          const topLabel = Array.isArray(children) ? children[0] : children;
          columnTitle = typeof topLabel === 'string' ? topLabel : topLabel?.props?.children || '';
        }

        if (typeof key === 'string') {
          formattedRow[columnTitle.trim()] = row[key];
        }
      });

      return formattedRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(dataBlob, `${fileName}.xlsx`);
  };

  const showdrivercallodal = () => {
    setadddrivercallmodal(true);
  };

  const hidedrivercallodal = (isVisible: any) => {
    DateSearch(fromdate, todate);
    setadddrivercallmodal(isVisible);
  };
  return (
    <div className="booking-child-routes">
      <div className="booking-child-routes-button-section">

        <Row
          align="middle"
          justify="space-between"
          style={{ paddingBottom: 10 }}
        >

          <Col>
            <span
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                fontFamily: "Times New Roman",
              }}
            >
              DRIVER CALLS REPORT
            </span>
          </Col>


          <Col>
            <Button

              onClick={showdrivercallodal}
              style={{
                backgroundColor: "green",
                color: "white",
                borderColor: "green",
              }}
            >
              Add Call
            </Button>
          </Col>


          <Col>
            <span
              style={{
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              Count : {drivercallsList.length}
            </span>
          </Col>
        </Row>

        <Row>

          <Col flex="auto" span={8} >
            <span style={{ fontSize: "medium" }}> From:</span>

            <DatePicker
              value={fromdate}
              format={dateFormat}
              disabledDate={disabledFromDate}
              onChange={onfromdatechange}
            />
            <span style={{ fontSize: "medium" }}> To:</span>

            <DatePicker
              //value={todate}
              value={
                todayFlag
                  ? moment()
                  : prevFlag
                    ? moment().add("days", -1)
                    : todate
              }
              format={dateFormat}
              disabledDate={disabledDate}
              onChange={ontodatechange}
            />

          </Col>


          <Col span={1} offset={0}>
            <Button
              className="booking-btn-blockSearch"
              onClick={() =>
                onDateSearch(fromdate, todate)
              }
              disabled={moment(fromdate).isAfter(moment(todate))}
            >
              Search
            </Button>
          </Col>
          <Col span={2} offset={2}>
            <Button
              className={
                ButtonClicked === "Today"
                  ? "booking-btn-buttonTrue"
                  : "booking-btn-buttonFalse"
              }
              onClick={adayclick}
            >
              Today
            </Button>
          </Col>
          <Col span={2} offset={0}>
            <Button
              className={
                ButtonClicked === "Yesday"
                  ? "booking-btn-buttonTrue"
                  : "booking-btn-buttonFalse"
              }
              onClick={twodayclick}
            >
              Prev
            </Button>
          </Col>
          <Col span={2} offset={0}>
            <Button
              className={
                ButtonClicked === "Month"
                  ? "booking-btn-buttonTrue"
                  : "booking-btn-buttonFalse"
              }
              onClick={monthclick}
            >
              Month
            </Button>
          </Col>
          {(Role == 1 || Role == 2) && (
            <Col span={2} offset={1}>
              <Button icon={<DownloadOutlined />} type="primary" onClick={() => exportToCSV(drivercallsList, columns)}>
              </Button>
            </Col>)}
          <Col span={3} offset={0}>
            <Input
              placeholder="Search Text"
              className="search"
              onChange={onSearchchange}
            />
          </Col>
        </Row>
        <div>
          <Spin tip="Loading..." spinning={isLoading}>
            <AppTable
              columns={columns}
              data={copydrivercallsList}
              enablePagination={true}
              defaultPageSize={100}
              scroll={{ x: "max-content" }}
            ></AppTable>
          </Spin>
          <AddDriverCall
            title="Add Driver Call"
            visible={adddrivercallmodal}
            hideModal={hidedrivercallodal}
          />
        </div>
      </div>
    </div>
  );
};

export default DriverCallsReports;
